import { useMemo } from 'react';
import { usePinnedFeaturesBySkuCategoryName } from './useFeatures';
export const useFormattedFeatureTableBodyData = ({
  productApiNames,
  skuCategoryName
}) => {
  const {
    featuresBySkuCategoryName,
    loading,
    error
  } = usePinnedFeaturesBySkuCategoryName({
    [skuCategoryName]: productApiNames
  });
  const formattedFeatureTableBodyData = useMemo(() => {
    const tableBodyData = {
      sharedData: {
        subscreen: ''
      },
      sectionData: {}
    };
    if (featuresBySkuCategoryName[skuCategoryName]) {
      tableBodyData.sectionData = {
        all: {
          LabelContent: 'All features',
          features: featuresBySkuCategoryName[skuCategoryName],
          alwaysExpanded: false,
          // @ts-expect-error FeatureTable expects ApiName type
          apiNames: productApiNames
        }
      };
    }
    return tableBodyData;
  }, [featuresBySkuCategoryName, skuCategoryName, productApiNames]);
  return {
    data: formattedFeatureTableBodyData || undefined,
    loading,
    error
  };
};